/*!
 * @license
 * SPDX-License-Identifier: LicenseRef-cloudEQ-Proprietary
 * Copyright (c) 2026-present cloudEQ Inc. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL.
 *
 * This source code, including all associated files, documentation, and
 * compiled forms, is the exclusive property of cloudEQ Inc. and is
 * protected by copyright, trade secret, and other intellectual property laws.
 *
 * This software is licensed, not sold, solely for use by authorized
 * licensees under the terms of a written license agreement with
 * cloudEQ Inc. Unless expressly permitted by that agreement, you may not
 * copy, modify, merge, distribute, sublicense, sell, publish, reverse
 * engineer, decompile, disassemble, or create derivative works of this
 * software, in whole or in part, by any means.
 *
 * Access to this file does not grant any license or right to use it.
 * Unauthorized use, reproduction, or disclosure is strictly prohibited and
 * may result in civil and criminal penalties.
 *
 * Contact: legal@cloudeq.com
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Conditional classes, with later Tailwind utilities beating earlier ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
